import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test070925 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 07/09/2025 Candidates</h3>
      <br />
      <br />



        <div><Link to='/conduct-naruporns'>1. AAT  2339  MR.NARUPORN  SAOWANIT(2DAN)---Trying for 3DAN</Link></div>
        <br />
        <div><Link to='/conduct-pongnarts'>2. AAT  6856  MR.PONGNART SAPSOMPONG(SHODAN-HO)---Trying for 1DAN </Link></div>
        <br />
        <div><Link to='/conduct-santis'>3. AAT  7518  MR.SANTI SIRISAK(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-pawanratc'>4. ATT  7731  MS.PAWANRAT CHUPINIJSAK(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>5. AAT  7951  MS.NAPASANUN VONGVIVAT(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>6. AAT  7952  MS.ISSARIYAPA ROOPSUWANNAKUL(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>7. AAT  8007  MR.KARNT SRISUWAN(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>8. AAT  8008  MR.PAKAWAD NANTAJURAPLO(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marcop'>9. AAT  8018  MR.MARCO PENNA(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-shinehl'>10. AAT  8019  MR.SHINE HTET LINN(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-suphatchayab'>11. AAT  8020  MS.SUPHATCHAYA BOONYASUKANON(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>12. AAT  8021  MS.VU NGUYEN QUYNH TRAM(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>13. AAT  8022  MR.CHAKCHAI ANUPONGPAT(WHITE BELT)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-chaiyutv'>***14. AAT  8017  MAJ.GEN CHAIYUT VAJIRAVARABHAKTI(Somboon Home-SHODAN-HO)---Belt Evaluation</Link></div>
        <br />
        <div><Link to='/conduct-suteed'>***15. AAT  8023  COL.SUTEE DUANGTOON(Somboon Home-SHODAN-HO)---Belt Evaluation</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test070925;
